// デザインシステムの CSS（pack CSS として出力され、stylesheet_pack_tag で配信される）
import '@/ui/styles.css';
import 'bootstrap';
import $ from 'jquery';
import ReactOnRails from 'react-on-rails';
// @ts-expect-error モジュール 'ahoy.js' に型定義が無いため
import ahoy from 'ahoy.js';
// @ts-expect-error モジュール '@rails/ujs' に型定義が無いため
import RailsUjs from '@rails/ujs';
// @ts-expect-error モジュール '@hotwired/turbo' に型定義が無いため
import * as Turbo from '@hotwired/turbo';
import { withQueryClient } from '@/common/http/withQueryClient';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import '@/config/sentry';
import 'slick-carousel';
import 'chart.js/auto';
import flashMessage from '@/common/utils/flashMessage';
import { mountToasterOnLoad } from '@/common/utils/toastBoot';

// JQuery plugins
import 'tempusdominus-bootstrap-4';
import 'jquery-jpostal-ja';

// summernote
import 'summernote/dist/summernote-bs4';
import 'summernote/lang/summernote-ja-JP';

// JQuery views
import ViewsInvestorsSpecificApplicationsUsersFormView from '@/common/views/investors/specific_applications/users/formView';
import ViewsInvestorsSpecificApplicationsUsersSelectPatternView from '@/common/views/investors/specific_applications/users/selectPatternView';
import ViewsInvestorsSpecificApplicationsUsersFileUploadView from '@/common/views/investors/specific_applications/users/fileUploadView';
import ViewsInvestorsSpecificApplicationsCorporatesFormView from '@/common/views/investors/specific_applications/corporates/formView';
import ViewsInvestorsSpecificApplicationsCorporatesSelectPatternView from '@/common/views/investors/specific_applications/corporates/selectPatternView';
import ViewsInvestorsSpecificApplicationsCorporatesFileUploadView from '@/common/views/investors/specific_applications/corporates/fileUploadView';
import ViewsMyInvestorsSpecificApplicationsFileUploadView from '@/common/views/investors/specific_applications/fileUploadView';
import ViewsCommonOtpView from './views/common/otpView';
import ViewsLayoutsBundleView from './views/layouts/bundleView';
import ViewsLayoutsPolicyReconsentModalView from './views/layouts/policyReconsentModalView';
import ViewsLayoutsRenewSpecificModalView from './views/layouts/renewSpecificModalView';
import ViewsMyUsersFormView from './views/my/users/formView';
import ViewsMyCompaniesBasicsFormView from './views/my/companies/basics/formView';
import ViewsMyCompaniesIrsFormView from './views/my/companies/irs/formView';
import ViewsMyCompaniesIrsEditorView from './views/my/companies/irs/editorView';
import ViewsMyCompaniesIrsTemplateView from './views/my/companies/irs/templateView';
import ViewsMyCompaniesIrsOnlineMeetingView from './views/my/companies/irs/onlineMeetingView';
import ViewsMyCompaniesIrsOnlineVotingView from './views/my/companies/irs/onlineVotingView';
import ViewsMyCompaniesFundingAgreementsFormView from './views/my/companies/funding/agreements/formView';
import ViewsMyInvestorsFormView from './views/my/investors/formView';
import ViewsMyInvestorsInterviewsFormView from './views/my/investors/interviews/formView';
import ViewsMyInvestorsCorporatesFormView from './views/my/investors/corporates/formView';
import ViewsMyInvestorsBeneficialOwnersFormView from './views/my/investors/beneficial_owners/formView';
import ViewsMyInvestorsTransactionPeopleFormView from './views/my/investors/transaction_people/formView';
import ViewsMyInvestorsCorporateDocumentsFormView from './views/my/investors/corporate_documents/formView';
import ViewsMyInvestorsSpecificApplicationsFormView from './views/my/investors/specific_applications/formView';
import ViewsMyInvestorsSpecificApplicationsUsersFileUploadRenewView from './views/my/investors/specific_applications/users/fileUploadRenewView';
import ViewsMyInvestorsSpecificApplicationsUsersConfirmView from './views/my/investors/specific_applications/users/confirmView';
import ViewsMyInvestorsSpecificApplicationsUsersRenewalConfirmView from './views/my/investors/specific_applications/users/renewalConfirmView';
import ViewsMyInvestorsSpecificApplicationsCorporatesConfirmView from './views/my/investors/specific_applications/corporates/confirmView';
import ViewsMyInvestorsSpecificApplicationsCorporatesRenewalConfirmView from './views/my/investors/specific_applications/corporates/renewalConfirmView';
import ViewsMyInvestorsOrdersMediaView from './views/my/investors/orders/mediaView';
import ViewsMyInvestorsOrdersCancelReasonsFormView from './views/my/investors/orders/cancel_reasons/formView';
import ViewsMyInvestorsReportsIndexView from './views/my/investors/reports/indexView';
import ViewsMyInvestorsPepsFormView from './views/my/investors/peps/formView';
import ViewsMyInvestorsIrsIndexView from './views/my/investors/irs/indexView';
import ViewsMyInvestorsIrsSearchView from './views/my/investors/irs/searchView';
import ViewsMyInvestorsAnnualReportsIndexView from './views/my/investors/annual_reports/indexView';
import ViewsMyInvestorsWizardBeneficialOwnersShowView from './views/my/investors/wizard/beneficial_owners/showView';
import ViewsMyInvestorsWizardUserIndividualsFormView from './views/my/investors/wizard/user_individuals/formView';
import ViewsMyInvestorsTradesIndexView from './views/my/investors/trades/indexView';
import ViewsMyInvestorsWizardUserIndividualsAgreementFormView from './views/my/investors/wizard/user_individuals/agreementFormView';
import ViewsMyIdentificationsFormView from './views/my/identifications/formView';
import ViewsMyIdentificationsEkycView from './views/my/identifications/ekycView';
import ViewsMyIdentificationsPreView from './views/my/identifications/preView';
import ViewsMyIdentificationsIndividualsFormView from './views/my/identifications/individuals/formView';
import ViewsMyPasswordsShowView from './views/my/passwords/showView';
import ViewsCmsContentsShowView from './views/cms_contents/showView';
import ViewsCompaniesGeneralMeetingsVotesShowView from './views/companies/general_meetings/votes/showView';
import ViewsCompaniesStockExchangesStockTransfersFormView from './views/companies/stock_exchanges/stock_transfers/formView';
import ViewsCompayContactsFormView from './views/compay_contacts/formView';
import ViewsContactsFormView from './views/contacts/formView';
import ViewsProjectsShowView from './views/projects/showView';
import ViewsProjectsV0ShowView from './views/projects/v0/showView';
import ViewsProjectsProductsOrdersContractsShowView from './views/projects/products/orders/contracts/showView';
import ViewsPlusInvestorContactView from './views/plus/investorContactView';
import ViewsPlusPlusProjectsShowView from './views/plus/plus_projects/showView';
import ViewsPlusProjectsFormView from './views/plus_projects/formView';
import ViewsQuitsFormView from './views/quits/formView';
import ViewsUsersRegistrationsFormView from './views/users/registrations/formView';
import ViewsUsersSessionsFormView from './views/users/sessions/formView';
import ViewsPagesFundingView from './views/pages/fundingView';
import ViewsPagesUserGuideView from './views/pages/userGuideView';
import ViewsPagesCampaignView from './views/pages/campaignView';
import ViewsPagesStatsView from './views/pages/statsView';
import ViewsPagesAboutShareholderCommunityView from './views/pages/aboutShareholderCommunityView';
import ViewsPagesAboutPageView from './views/pages/aboutPageView';
import ViewsPagesAboutCompanyPageView from './views/pages/aboutCompanyPageView';
import ViewsAboutCompanyCasesCaseShowView from './views/about_company/cases/caseShowView';
import ViewsShareholderCommunitiesIndexView from './views/shareholder_communities/indexView';
import ViewsShareholderCommunitiesShowView from './views/shareholder_communities/showView';
import ViewsShareholderCommunitiesTypeRatio from './views/shareholder_communities/typeRatio';
import ViewsShareholderCommunitiesLeavesShowView from './views/shareholder_communities/leaves/showView';
import ViewsShareholderCommunitiesTradesFormView from './views/shareholder_communities/trades/formView';
import ViewsWhitePapersDownloadsFormView from './views/white_papers/downloads/formView';
import ViewsLpsFundraisingSimsShowView from './views/lps/fundraising_sims/showView';
import ViewsLpsPageView from './views/lps/pageView';
import ViewsSharedCampaignFloatingBannerView from './views/shared/campaignFloatingBannerView';

// React components for ReactOnRails
import ViewsCompaniesIndexView from './views/companies/indexView';
import ViewsMyInvestorsBankView from './views/my/investors/bankView';
import ViewsProjectsIndexView from './views/projects/indexView';
import ViewsQuestionsAngelTaxView from './views/questions/angelTaxView';
import ViewsMyCompaniesKyccsCompaniesShowView from './views/my/companies/kyccs/companies/showView';
import ViewsMyCompaniesKyccsCustomersShowView from './views/my/companies/kyccs/customers/showView';
import ViewsMyInvestorsDemandQuestionairesSelectCompaniesToSellView from './views/my/investors/shareholder_communities/demand_questionnaires/selectCompaniesToSellView';
import ViewsMyInvestorsDemandQuestionairesSelectCompaniesToBuyView from './views/my/investors/shareholder_communities/demand_questionnaires/selectCompaniesToBuyView';
import ViewsMyInvestorsDemandQuestionairesInputOtherVentureCompaniesView from './views/my/investors/shareholder_communities/demand_questionnaires/inputOtherVentureCompaniesView';
import ViewsMyinvestorsWizardUserIndividualsBankView from './views/my/investors/wizard/user_individuals/bankView';
import ViewsLpsFundraisingSimsPageView from './views/lps/fundraising_sims/pageView';
import ViewsLpsFundraisingSimsSimulatorView from './views/lps/fundraising_sims/SimulatorView';
import ViewsLpsAngeltaxType3SimulatorView from './views/lps/angeltax_type3/simulatorView';
import ViewsLpsAngeltaxType3ProjectsView from './views/lps/angeltax_type3/projectsView';
import ViewsPlusInvestorContactFormView from './views/plus/investorContactFormView';
import ViewsPlusPlusProjectsIndexView from './views/plus/plus_projects/indexView';

interface Window {
  jQuery: JQueryStatic;
  $: JQueryStatic;
  views: Record<string, unknown>;
  notify: (
    title: string,
    message: string,
    from: string,
    align: string,
    icon: string,
    type: string,
    animIn: string,
    animOut: string,
  ) => void;
}

declare let window: Window;

window.jQuery = $;
window.$ = $;
window.notify = flashMessage;
// トーストの置き場 (#toast-host) はレイアウトが描画する。pack は defer:false で読まれるため、DOMContentLoaded を待ってから mount する
mountToasterOnLoad();

// Rails
RailsUjs.start();
Turbo.session.drive = false;

ahoy.trackAll();

window.views = {
  common: {
    OtpView: ViewsCommonOtpView,
  },
  layouts: {
    BundleView: ViewsLayoutsBundleView,
    PolicyReconsentModalView: ViewsLayoutsPolicyReconsentModalView,
    RenewSpecificModalView: ViewsLayoutsRenewSpecificModalView,
  },
  my: {
    users: {
      FormView: ViewsMyUsersFormView,
    },
    companies: {
      basics: {
        FormView: ViewsMyCompaniesBasicsFormView,
      },
      irs: {
        FormView: ViewsMyCompaniesIrsFormView,
        EditorView: ViewsMyCompaniesIrsEditorView,
        TemplateView: ViewsMyCompaniesIrsTemplateView,
        OnlineMeetingView: ViewsMyCompaniesIrsOnlineMeetingView,
        OnlineVotingView: ViewsMyCompaniesIrsOnlineVotingView,
      },
      funding: {
        agreements: {
          FormView: ViewsMyCompaniesFundingAgreementsFormView,
        },
      },
    },
    investors: {
      FormView: ViewsMyInvestorsFormView,
      interviews: {
        FormView: ViewsMyInvestorsInterviewsFormView,
      },
      corporates: {
        FormView: ViewsMyInvestorsCorporatesFormView,
      },
      beneficial_owners: {
        FormView: ViewsMyInvestorsBeneficialOwnersFormView,
      },
      transaction_people: {
        FormView: ViewsMyInvestorsTransactionPeopleFormView,
      },
      corporate_documents: {
        FormView: ViewsMyInvestorsCorporateDocumentsFormView,
      },
      specific_applications: {
        FormView: ViewsMyInvestorsSpecificApplicationsFormView,
        users: {
          FormView: ViewsInvestorsSpecificApplicationsUsersFormView,
          SelectPatternView:
            ViewsInvestorsSpecificApplicationsUsersSelectPatternView,
          FileUploadView: ViewsInvestorsSpecificApplicationsUsersFileUploadView,
          FileUploadRenewView:
            ViewsMyInvestorsSpecificApplicationsUsersFileUploadRenewView,
          ConfirmView: ViewsMyInvestorsSpecificApplicationsUsersConfirmView,
          RenewalConfirmView:
            ViewsMyInvestorsSpecificApplicationsUsersRenewalConfirmView,
        },
        corporates: {
          FormView: ViewsInvestorsSpecificApplicationsCorporatesFormView,
          SelectPatternView:
            ViewsInvestorsSpecificApplicationsCorporatesSelectPatternView,
          FileUploadView:
            ViewsInvestorsSpecificApplicationsCorporatesFileUploadView,
          ConfirmView:
            ViewsMyInvestorsSpecificApplicationsCorporatesConfirmView,
          RenewalConfirmView:
            ViewsMyInvestorsSpecificApplicationsCorporatesRenewalConfirmView,
        },
      },
      orders: {
        MediaView: ViewsMyInvestorsOrdersMediaView,
        cancel_reasons: {
          FormView: ViewsMyInvestorsOrdersCancelReasonsFormView,
        },
      },
      reports: {
        IndexView: ViewsMyInvestorsReportsIndexView,
      },
      peps: {
        FormView: ViewsMyInvestorsPepsFormView,
      },
      irs: {
        IndexView: ViewsMyInvestorsIrsIndexView,
        SearchView: ViewsMyInvestorsIrsSearchView,
      },
      annual_reports: {
        IndexView: ViewsMyInvestorsAnnualReportsIndexView,
      },
      wizard: {
        beneficial_owners: {
          ShowView: ViewsMyInvestorsWizardBeneficialOwnersShowView,
        },
        user_individuals: {
          FormView: ViewsMyInvestorsWizardUserIndividualsFormView,
        },
      },
      trades: {
        IndexView: ViewsMyInvestorsTradesIndexView,
      },
      user_individuals: {
        AgreementFormView:
          ViewsMyInvestorsWizardUserIndividualsAgreementFormView,
      },
    },
    identifications: {
      FormView: ViewsMyIdentificationsFormView,
      EkycView: ViewsMyIdentificationsEkycView,
      PreView: ViewsMyIdentificationsPreView,
      individuals: {
        FormView: ViewsMyIdentificationsIndividualsFormView,
      },
    },
    passwords: {
      ShowView: ViewsMyPasswordsShowView,
    },
  },
  cms_contents: {
    ShowView: ViewsCmsContentsShowView,
  },
  companies: {
    general_meetings: {
      votes: {
        ShowView: ViewsCompaniesGeneralMeetingsVotesShowView,
      },
    },
    stock_exchanges: {
      stock_transfers: {
        FormView: ViewsCompaniesStockExchangesStockTransfersFormView,
      },
    },
  },
  compay_contacts: {
    FormView: ViewsCompayContactsFormView,
  },
  contacts: {
    FormView: ViewsContactsFormView,
  },
  projects: {
    ShowView: ViewsProjectsShowView,
    v0: {
      ShowView: ViewsProjectsV0ShowView,
    },
    products: {
      orders: {
        contracts: {
          ShowView: ViewsProjectsProductsOrdersContractsShowView,
        },
      },
    },
  },
  plus: {
    InvestorContactView: ViewsPlusInvestorContactView,
    plus_projects: {
      ShowView: ViewsPlusPlusProjectsShowView,
    },
  },
  plus_projects: {
    FormView: ViewsPlusProjectsFormView,
  },
  quits: {
    FormView: ViewsQuitsFormView,
  },
  users: {
    registrations: {
      FormView: ViewsUsersRegistrationsFormView,
    },
    sessions: {
      FormView: ViewsUsersSessionsFormView,
    },
  },
  pages: {
    FundingView: ViewsPagesFundingView,
    UserGuideView: ViewsPagesUserGuideView,
    CampaignView: ViewsPagesCampaignView,
    StatsView: ViewsPagesStatsView,
    AboutShareholderCommunityView: ViewsPagesAboutShareholderCommunityView,
    AboutPageView: ViewsPagesAboutPageView,
    AboutCompanyPageView: ViewsPagesAboutCompanyPageView,
  },
  about_company: {
    cases: {
      CaseShowView: ViewsAboutCompanyCasesCaseShowView,
    },
  },
  shareholder_communities: {
    IndexView: ViewsShareholderCommunitiesIndexView,
    ShowView: ViewsShareholderCommunitiesShowView,
    TypeRatio: ViewsShareholderCommunitiesTypeRatio,
    leaves: {
      ShowView: ViewsShareholderCommunitiesLeavesShowView,
    },
    trades: {
      FormView: ViewsShareholderCommunitiesTradesFormView,
    },
  },
  white_papers: {
    downloads: {
      FormView: ViewsWhitePapersDownloadsFormView,
    },
  },
  shared: {
    CampaignFloatingBannerView: ViewsSharedCampaignFloatingBannerView,
  },
  lps: {
    fundraisingSims: {
      ShowView: ViewsLpsFundraisingSimsShowView,
    },
    PageView: ViewsLpsPageView,
  },
};

ReactOnRails.register(
  withQueryClient({
    ViewsCompaniesIndexView,
    ViewsMyInvestorsBankView,
    ViewsProjectsIndexView,
    ViewsQuestionsAngelTaxView,
    ViewsMyCompaniesKyccsCompaniesShowView,
    ViewsMyCompaniesKyccsCustomersShowView,
    ViewsMyInvestorsSpecificApplicationsFileUploadView,
    ViewsMyInvestorsDemandQuestionairesSelectCompaniesToSellView,
    ViewsMyInvestorsDemandQuestionairesSelectCompaniesToBuyView,
    ViewsMyInvestorsDemandQuestionairesInputOtherVentureCompaniesView,
    ViewsMyinvestorsWizardUserIndividualsBankView,
    ViewsLpsFundraisingSimsPageView,
    ViewsLpsFundraisingSimsSimulatorView,
    ViewsLpsAngeltaxType3SimulatorView,
    ViewsLpsAngeltaxType3ProjectsView,
    ViewsPlusInvestorContactFormView,
    ViewsPlusPlusProjectsIndexView,
  }),
);
